import React, {forwardRef} from 'react';
import {ESBA_DATE_FORMAT} from '../index';
import {useDateInputFinish} from '../hook/useDateInputFinish';

type DatePickerInputProps = {
    fieldName: string
    value?: string;
    placeholder?: string;
    onClick?: () => void;
    onChange?: () => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    onFinish?: (date: Date | null) => void; // Callback when Enter is pressed or input loses focus. Called with Date for valid input, null for empty value
    dateFormat?: string; // Date format for parsing (default: ESBA_DATE_FORMAT)
};

export const DatePickerInput = forwardRef<HTMLInputElement, DatePickerInputProps>(
    ({fieldName, value, placeholder, onClick, onChange, onKeyDown, onBlur, onFinish, dateFormat = ESBA_DATE_FORMAT}, ref) => {
        const { handleKeyDown, handleBlur } = useDateInputFinish({
            onFinish,
            dateFormat,
            onKeyDown,
            onBlur,
        });

        return (
            <div className={"h-w"}>
                <input
                    autoComplete={"off"}
                    className="block appearance-none w-full bg-white border border-gray-400 hover:border-atlantis-100 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    id={fieldName}
                    value={value}
                    placeholder={placeholder}
                    onClick={onClick}
                    onChange={onChange}
                    onKeyDown={handleKeyDown}
                    onBlur={handleBlur}
                    ref={ref}
                />
            </div>
        );
    }
);
